export default "__VITE_ASSET__108227af__"